import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, Button, Divider, useMediaQuery } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

function CustomTable({
  lpPriceUSDC,
  stakedLp,
  conversionRate,
  conversionCost1,
  conversionCost2,
  conversionCost3,
  setnodeTypeIndex,
  nodeTypeIndex,
}) {
  const mobile = useMediaQuery("(max-width:1050px)");
  return (
    <div
      style={{
        marginX: "20px",
      }}
    >
      {" "}
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>
                {" "}
                <Box
                  sx={{
                    fontSize: mobile ? "14px" : "18px",
                    fontWeight: "400",
                    color: "#FAA631",
                    // textAlign: "center",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontSize: mobile ? "14px" : "18px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                      fontFamily: "light",
                    }}
                  >
                    {" "}
                    Type
                  </Box>
                </Box>
              </TableCell>
              <TableCell>
                {" "}
                <Box
                  sx={{
                    fontSize: mobile ? "14px" : "18px",
                    fontWeight: "400",
                    color: "#FAA631",
                    // textAlign: "center",
                    fontFamily: "light",
                  }}
                >
                  Discount
                </Box>
              </TableCell>
              <TableCell>
                {" "}
                <Box
                  sx={{
                    fontSize: mobile ? "14px" : "18px",
                    fontWeight: "400",
                    color: "#FAA631",
                    // textAlign: "center",
                    fontFamily: "light",
                  }}
                >
                  Node Conversion
                </Box>
              </TableCell>
              <TableCell>
                {" "}
                <Box
                  sx={{
                    fontSize: mobile ? "14px" : "18px",
                    fontWeight: "400",
                    color: "#FAA631",
                    // textAlign: "center",
                    fontFamily: "light",
                  }}
                >
                  Conversion Discount
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow

            // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell
                width={mobile ? "85px" : null}
                component="th"
                scope="row"
              >
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  SILVER
                </Box>
              </TableCell>
              <TableCell width={mobile ? "85px" : null}>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  {conversionRate}%
                </Box>
              </TableCell>
              <TableCell width={mobile ? "85px" : null}>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  ${conversionCost1}
                </Box>
              </TableCell>

              <TableCell width={mobile ? "85px" : null}>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  {Math.floor((stakedLp * lpPriceUSDC) / conversionCost1)}
                </Box>
              </TableCell>
            </TableRow>

            <TableRow

            // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  DIAMOND
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  {" "}
                  {conversionRate}%
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  ${conversionCost2}
                </Box>
              </TableCell>

              <TableCell>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  {Math.floor((stakedLp * lpPriceUSDC) / conversionCost2)}
                </Box>
              </TableCell>
            </TableRow>

            <TableRow

            // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  GOLD
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  {conversionRate}%
                </Box>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  ${conversionCost3}
                </Box>
              </TableCell>

              <TableCell>
                <Box
                  sx={{
                    fontSize: mobile ? "12px" : "14px",
                    fontWeight: "400",
                    color: "white",
                    // textAlign: "center",
                    fontFamily: "regular",
                  }}
                >
                  {Math.floor((stakedLp * lpPriceUSDC) / conversionCost3)}
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Divider width="100%" sx={{ background: "white", height: "1px" }} />
      </TableContainer>
      <Box my="20px">
        <FormControl>
          <FormLabel
            sx={{
              fontSize: mobile ? "14px" : "18px",
              fontWeight: "400",

              // textAlign: "center",
              fontFamily: "light",
              color: "white",
            }}
            id="demo-row-radio-buttons-group-label"
          >
            Select Node Type
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={nodeTypeIndex}
            onChange={(e) => setnodeTypeIndex(e.target.value)}
          >
            <FormControlLabel
              sx={{
                fontSize: mobile ? "12px" : "14px",
                fontWeight: "400",
                color: "white",
                fontFamily: "regular",
              }}
              value="0"
              control={<Radio />}
              label="Silver"
            />
            <FormControlLabel
              sx={{
                fontSize: mobile ? "12px" : "14px",
                fontWeight: "400",
                color: "white",
                fontFamily: "regular",
              }}
              value="1"
              control={<Radio />}
              label="Diamond"
            />

            <FormControlLabel
              sx={{
                fontSize: mobile ? "12px" : "14px",
                fontWeight: "400",
                color: "white",
                fontFamily: "regular",
              }}
              value="2"
              control={<Radio />}
              label="Gold"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </div>
  );
}

export default CustomTable;
